<template>
  <el-form-item>
    <el-popover placement="bottom" width="750" trigger="click">
      <el-form class="form-table" inline size="small" style="margin-right: -12px;">
        <slot />
        <el-form-item>
          <el-button icon="el-icon-setting" type="primary" plain @click="$emit('update:visible', true)">
            筛选设置
          </el-button>
        </el-form-item>
      </el-form>
      <el-button slot="reference">更多筛选</el-button>
    </el-popover>
  </el-form-item>
</template>

<script>
export default {
  name: 'FormItemPopover',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>
